module.exports = __webpack_public_path__ + "static/media/photo_035.33b17226.JPG";